import { InventoryRow } from "./inventory.defs";

export class Inventory {

	id: number;
	name: string;
	price: number;
	product: boolean;
	service: boolean;

	customTimes = new Map<number /** barber */, number /** minutes */>();
	private _minuteDefault: number;

	constructor(
		private _params: InventoryRow
	) {
		if (_params) {
			this.load(_params);
		}
	}

	getDuration(barber?: number): number {
		return (barber ? this.customTimes.get(barber) : 0 ) || this._minuteDefault;
	}

	load(p: InventoryRow) {
		// console.log('loading', p);
		
		this.id = p.id;
		this.name = p.ITEM;

		this._minuteDefault = p.MINUTES;
		this.price = p.PRICE;

		this.product = p.TYPE === 'PRODUCT';
		this.service = p.TYPE === 'SERVICE';
		
	}

}